import styled from 'styled-components';

import { BasicSectionContainer } from '../../../../../style';
import { colors } from 'constants/colors';
import { styleSizes } from 'constants/styleSizes';

export const EditCreditCardContentContainer = styled(BasicSectionContainer)`
  min-width: 260px;
`;

export const EditCreditCardFormContainer = styled.div`
  width: 100%;
  max-width: 854px;
  padding: 32px;
  background: ${colors.white};
  box-sizing: border-box;
  width: 100%;
  max-width: 854px;
  padding: 32px;
  background: ${colors.white};
  box-sizing: border-box;
  -webkit-box-shadow: 0px 1px 3px 0px ${colors.accounMenuBorderShadowColor};
  -moz-box-shadow: 0px 1px 3px 0px ${colors.accounMenuBorderShadowColor};
   box-shadow: 0px 1px 3px 0px ${colors.accounMenuBorderShadowColor};
   border: 1px solid ${colors.signInBorderColor};
   @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
    padding: 0;
    -webkit-box-shadow:none;
    -moz-box-shadow: none;
    box-shadow: none;
    border: 0;
   }
  .description {
    max-width: 790px;
    margin: 0 0 36px 0;
    font-size: 16px;
    line-height: 26px;
    color: ${colors.almostBlack};
  }

  .editCreditCardInput {
    max-width: 500px;
    margin-bottom: 32px;
  }

  .cardDetailsRow {
    max-width: 500px;
    display: flex;
    gap: 8px;

    .editCreditCardInput {
      flex: 1;
    }
  }

  @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {


    .description {
      font-size: 16px;
      line-height: 24px;
    }

    .editCreditCardInput {
      max-width: 100%;
      margin-bottom: 24px;

    }

    .editCreditCardInputBillingAddress {
      margin-bottom: 32px;
    }

    .cardDetailsRow {
      max-width: 100%;
      flex-direction: column;
      gap: 0;
    }
  }
`;

export const EditCreditCardButtonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  padding-top: 16px;
  @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
    flex-direction: row-reverse;
    padding-top: 24px;
  }
`;

export const EditCreditCardSaveButton = styled.button`
  height: 48px;
  padding: 0 24px;
  border: none;
  background: ${colors.hoverBlue};
  color: ${colors.white};
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
`;

export const EditCreditCardCancelButton = styled.button`
  border: none;
  background: transparent;
  color: ${colors.hoverBlue};
  font-size: 16px;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
`;